import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DialogButton } from '../../homePage/components/dialogButton';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInitialData, showDialog, setEditedProfile } from '../../../redux/applicationSlice';
import LockInputs from './LockInputs';
import ProfileLockButtons from './ProfileLockButtons';

const ProfileLock = () => {
    const navigate = useNavigate();
    const { user, logo, theme, profiles, selectedProfile, ottSettings, editedProfile, dialog } = useSelector((state) => state.application);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!ottSettings) {
            dispatch(fetchInitialData());
        }
    }, [dispatch]);

    const [disableParentalLock, setDisableParentalLock] = useState(false);
    const [resetPin, setResetPin] = useState(false);
    const [oldPassword, _setOldPassword] = useState([]);
    const passwordRef = useRef([]);
    const setOldPassword = (value) => {
        passwordRef.current = value;
        _setOldPassword([...value]);
    }
    const [newPassword, _setNewPassword] = useState([]);
    const setNewPassword = (value) => {
        passwordRef.current = value;
        _setNewPassword([...value]);
    }
    const [isConfirmPin, setIsConfirmPin] = useState(false);

    const { ref: dialogRef, focusKey: dialogFocusKey, focusSelf: focusDialog } = useFocusable({
        focusKey: "dialog-container",
    });

    const onInput = (value) => {
        if (value == 'back') {
            if (isConfirmPin && passwordRef.current.length == 0) {
                setIsConfirmPin(false);
                setOldPassword([]);
            }
            if (!isConfirmPin && passwordRef.current.length == 0) {
                navigate(-1);
            }
            let changedPassword = passwordRef.current;
            changedPassword.pop();
            if (isConfirmPin) {
                setNewPassword(changedPassword);
            } else {
                setOldPassword(changedPassword);
            }
        } else if (value == 'done') {
            if (passwordRef.current.length < 4) {
                dispatch(showDialog(
                    {
                        message: 'Please Complete PIN',
                    }));
                return;
            }
            else if (isConfirmPin) {
                if (!resetPin && oldPassword.join('') != newPassword.join('')) {
                    dispatch(showDialog({
                        message: 'PIN didn\'t match'
                    }));
                    setTimeout(() => {
                        focusDialog();
                    }, 500);
                    setIsConfirmPin(false);
                    setNewPassword([]);
                    setOldPassword([]);
                    return;
                } else {
                    dispatch(setEditedProfile({ ...editedProfile, EnableParentalControl: true, Pin: passwordRef.current.join('') }));
                    return navigate(-1);
                }
            }
            else if (passwordRef.current.join('') == '0000') {
                dispatch(showDialog({
                    message: 'PIN cannot be 0000'
                }));
                return;
            }
            else {
                if (disableParentalLock) {
                    if (passwordRef.current.join('') == editedProfile.Pin) {
                        dispatch(setEditedProfile({ ...editedProfile, EnableParentalControl: false, Pin: '0000' }));
                        return navigate(-1);
                    } else {
                        dispatch(showDialog({
                            message: 'Incorrect PIN'
                        }));
                        setTimeout(() => {
                            focusDialog();
                        }, 500);
                        return;
                    }
                }
                if (resetPin) {
                    if (passwordRef.current.join('') != editedProfile.Pin) {
                        dispatch(showDialog({
                            message: 'Incorrect PIN'
                        }));
                        setTimeout(() => {
                            focusDialog();
                        }, 500);
                        return;
                    }
                }
                setIsConfirmPin(true);
                passwordRef.current = [];
            }
        } else {
            if (passwordRef.current.length > 3) {
                return;
            }
            let changedPassword = passwordRef.current;
            changedPassword.push(value);
            if (isConfirmPin) {
                setNewPassword(changedPassword);
            } else {
                setOldPassword(changedPassword);
            }
        }
    }

    const { ref, focused, focusKey, focusSelf } = useFocusable({
        focusKey: "lock-inputs",
        isFocusBoundary: true,
        saveLastFocusedChild: false,
        onArrowPress: (direction) => {
            return true;
        },
    });

    useEffect(() => {
        focusSelf();
    }, []);

    const numberBoxArray = [1, 2, 3, 4, 5, 6, 7, 8, <i className={`fa fa-${passwordRef.current.length == 0 ? "chevron-left" : "delete-left"}`} style={{ color: passwordRef.current.length == 0 ? "#e84d31" : "white" }} />, 9, 0, <i className={`fa fa-${(isConfirmPin && passwordRef.current.length == 4) ? "check" : "chevron-right"}`} style={{ color: "#22c95c" }} />];

    return (

        <div style={{ display: 'flex', alignItems: 'center', height: '100vh', backgroundColor: theme?.general?.bgColor ?? "#000000", color: theme?.general?.color ?? "#828282", paddingTop: "20px", flexDirection: "column" }}>
            <img src={logo} style={{ height: "100px" }} />
            <FocusContext.Provider value={focusKey}>
                {!(disableParentalLock || resetPin) && editedProfile.EnableParentalControl ? <>
                    <div className='plock-wrapper'>
                        <div className='plock'>

                        </div>
                        <div className='plock-icon'>
                            <i className='fa fa-lock fa-3x' />
                        </div>
                    </div>
                    <p style={{ fontSize: "32px", fontWeight: "bold", letterSpacing: "1.5px", marginTop: "10px", fontFamily: "roboto" }}>Profile is Locked</p>
                    <p style={{ fontSize: "20px", fontWeight: "bold", letterSpacing: "1.5px", marginBottom: "40px", fontFamily: "roboto", color: "gray" }}>Your profile is secure and protected</p>

                    <ProfileLockButtons text="Disable Parental Lock" focusKey="disable-parental-lock" bgColor="#e84d31" onClick={() => { setDisableParentalLock(true); }} />

                    <ProfileLockButtons text="Reset PIN" focusKey="Reset-PIN-parental-lock" bgColor="#0077b5" onClick={() => { setResetPin(true); }} />

                </> : <>
                    <p style={{ fontSize: "32px", fontWeight: "bold", letterSpacing: "1px", marginTop: "10px" }}>{disableParentalLock ? "Disable Parental Lock" : isConfirmPin ? resetPin ? "New PIN" : "Confirm Your PIN" : resetPin ? "Old PIN" : "Create a PIN"}</p>
                    <li className='lock-digits'>
                        <ul>{isConfirmPin ? (newPassword[0] ?? "") : (oldPassword[0] ?? "")}</ul>
                        <ul>{isConfirmPin ? (newPassword[1] ?? "") : (oldPassword[1] ?? "")}</ul>
                        <ul>{isConfirmPin ? (newPassword[2] ?? "") : (oldPassword[2] ?? "")}</ul>
                        <ul>{isConfirmPin ? (newPassword[3] ?? "") : (oldPassword[3] ?? "")}</ul>
                    </li>

                    <div className='lock-inputs-box'>
                        <li ref={ref} className='lock-inputs'>
                            {numberBoxArray.map((x, index) => <LockInputs key={index} index={index} x={x} onInput={onInput} />)}
                        </li>
                    </div>

                </>}
            </FocusContext.Provider>

        </div>


    );
}

export default ProfileLock;
